<template>
  <div id="login">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-col cols="12" sm="2" xl="6" xs="2" lg="6" md="6">
          <v-row
            align="center"
            justify="center"
            style="margin-top: 60px"
            v-if="state == 0"
          >
            <v-card
              width="450"
              :height="isMobile ? '460' : '500'"
              color="white"
              shaped
              elevation="4"
              :class="isMobile ? 'mt-n10' : isLargescreen ? 'mt-10' : 'mt-n8'"
            >
              <v-card-text :class="isMobile ? 'mt-n3' : 'mt-n3'">
                <div class="layout column align-center">
                  <img src="@/assets/glyd.png" width="200" height="200" />

                  <!-- <h1 class="flex my-2">Sign In</h1> -->
                </div>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    v-model="display_id"
                    label="Login User ID *"
                    type="text"
                    required
                    solo
                    rounded
                    dense
                    class="mt-n4"
                    @keyup.enter="login"
                    append-icon="mdi-identifier"
                    :rules="[(v) => !!v || 'Login user id is required']"
                    @keyup="capsfnction()"
                  ></v-text-field>
                  <v-text-field
                    v-model="email"
                    label="Email *"
                    :rules="[
                      (v) => !!v || 'E-mail is required',
                      (v) => /.+@.+/.test(v) || 'E-mail must be valid',
                    ]"
                    type="text"
                    required
                    solo
                    rounded
                    dense
                    @keyup.enter="login"
                    append-icon="mdi-email"
                  ></v-text-field>
                  <v-text-field
                    label="Password *"
                    :append-icon="show3 ? 'visibility' : 'visibility_off'"
                    :rules="rules.password"
                    :type="show3 ? 'text' : 'password'"
                    @click:append="show3 = !show3"
                    v-model="password"
                    required
                    solo
                    rounded
                    dense
                    @keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>

              <v-card-actions class="mr-2 ml-2">
                <v-btn
                  block
                  class="primary--text btn font-weight-bold"
                  :loading="loadingLogin"
                  @keyup.enter="login"
                  @click="login"
                  rounded
                  >Login</v-btn
                >
              </v-card-actions>
              <v-card-actions>
                <v-row align="center" justify="center">
                  <a class="loginsmalltext mt-3 mb-3" @click="forgotPassword()" >
                    <u>Forgot password ?</u>
                  </a>
                </v-row>
                <!-- <v-spacer />
                <a @click="signup" class="loginsmalltext mt-n3 mr-4">
                  <u>Sign up ?</u>
                </a> -->
              </v-card-actions>
            </v-card>
          </v-row>

          <v-row
            align="center"
            justify="center"
            style="margin-top: 70px; margin-top: 150px"
            v-if="state == 1"
          >
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="@/assets/glyd.png" width="200" height="200" />
                  <h1 class="flex my-4">Reset Password</h1>
                  <br />
                </div>
                <v-form @submit.prevent="false" ref="formReset">
                  <v-flex>
                    <v-text-field
                      :append-icon="show1 ? 'visibility' : 'visibility_off'"
                      :rules="pwdRules"
                      :type="show1 ? 'text' : 'password'"
                      name="input-10-2"
                      label="New Password"
                      hint="At least 8 characters"
                      v-model="newPassword"
                      class="input-group--focused"
                      @click:append="show1 = !show1"
                      @keyup.enter="login"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      :append-icon="show2 ? 'visibility' : 'visibility_off'"
                      :rules="pwdConfirm"
                      :type="show2 ? 'text' : 'password'"
                      name="input-10-2"
                      label="Confirm Password"
                      hint="At least 8 characters"
                      v-model="confirmPassword"
                      @click:append="show2 = !show2"
                      @keyup.enter="setNewPassword()"
                    ></v-text-field>
                  </v-flex>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <a
                  class="textcolor-grey"
                  @click="state-- & reset()"
                  v-if="state == 1"
                >
                  <u>Back</u>
                </a>
                <v-spacer></v-spacer>
                <v-btn
                  block
                  class="#1b3249--text btn"
                  @click="setNewPassword()"
                  :loading="loading"
                  >Confirm</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" xl="6" xs="2" lg="6" md="6" class="mt-n3 ml-n1">
          <v-row
            align="center"
            justify="center"
            :class="isMobile ? 'mt-3' : isLargescreen ? 'mt-9' : 'mb-6'"
          >
            <span
              :class="!isMobile ? 'white--text' : ' primary--text'"
              style="
                font-size: 20px;
                font-style: italic;
                font-family: Times New Roman;
              "
              ><b>New Here ?</b></span
            >
            <span
              :class="!isMobile ? 'white--text' : ' primary--text'"
              style="
                font-size: 20px;
                margin-left: 10px;
                font-style: italic;
                font-family: Times New Roman;
              "
            >
              Sign up for <b>GLYD</b> now
            </span>
          </v-row>
          <!-- <v-row align="center" justify="center" class="mb-4">
            <span
              class="white--text"
              style="
                font-size: x-large;
                font-style: italic;
                font-family: Times New Roman;
              "
            >
              Sign up for <b>GLYD</b> now
            </span>
          </v-row> -->
          <!-- <v-row align="center" justify="center" style="margin-top: 10px">
            <span class="primary--text" style="font-size: large">
              amount of new opportunities
            </span>
          </v-row> -->
          <v-row align="center" justify="center">
            <v-card-actions
              :class="isMobile ? 'mt-6' : isLargescreen ? 'mt-6' : 'mt-n4'"
            >
              <v-btn
                class="primary--text btn font-weight-bold"
                @click="signup"
                rounded
                width="200px"
                >Sign Up</v-btn
              >
            </v-card-actions>
          </v-row>
        </v-col>
      </v-container>
      <v-snackbar
        v-model="snackbar"
        color="warning"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        top
        center
        :timeout="1000"
      >
        <v-spacer></v-spacer>
        {{ snackbarMsg }}
        <v-btn color="black" @click="snackbar = false">Close</v-btn>
        <v-spacer></v-spacer>
      </v-snackbar>
    </v-content>
    <v-dialog
      v-model="ConfirmDialog"
      height="500"
      width="600"
      persistent
      overlay-color="primary"
      overlay-opacity="0.9"
    >
      <v-card class="overflow-hidden" color="white" rounded="xl">
        <v-card-text v-if="verificationstatus == 4"
          style="
            font-style: normal;
            font-size: 18px;
            font-family: Times New Roman;
            margin-top: 30px;
          "
          class="font-weight-light black--text"
        >
        Dear Customer, Unfortunately your GLYD account has been deactivated. Please contact administrator.
        </v-card-text>
        <v-card-text v-else-if="verificationstatus == 6"
          style="
            font-style: normal;
            font-size: 18px;
            font-family: Times New Roman;
            margin-top: 30px;
          "
           class="font-weight-light black--text"
        >
        Dear Customer, your GLYD account activation has been initiated, but is still pending. 
        Please contact the administrator for further assistance.

        </v-card-text>
        <v-card-text v-else-if="verificationstatus == 5"
          style="
            font-style: normal;
            font-size: 18px;
            font-family: Times New Roman;
            margin-top: 30px;
          "
           class="font-weight-light black--text"
        >
        Dear Customer, your GLYD account deactivation has been initiated, but is still pending. 
        Please contact the administrator for further assistance.

        </v-card-text>
        <v-card-actions>
          <v-row class="mt-n6">
            <v-col cols="12" md="4">
              <v-img
                src="@/assets/glyd1.svg"
                width="120px"
                max-height="80px"
              ></v-img
            ></v-col>
            <v-col cols="12" md="6"></v-col>
            <v-col cols="12" md="1" class="mt-6">
              <v-btn color="primary " text @click="navigatortoLogin">
               close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import { Auth } from "aws-amplify";
import { apiCall } from "@/Views/APICALL/APIcall.js";

// import { validateUser } from "@/graphql/graphqlapi.js";
export default {
  data() {
    return {
      loadingLogin: false,
      show3: false,
      corpcount: "",
      mode: "top",
      snackbar: false,
      snackbarMsg: "Invalid Email and Password",
      loading: false,
      valid: true,
      email: "",
      display_id: "",
      password: "",
      confirmPassword: "",
      newPassword: "",
      show: false,
      show1: false,

      show2: false,
      state: 0,
      userList: [],
      pwdRules: [(v) => !!v || "Password required"],
      pwdConfirm: [
        (v) => !!v || "Confirm password",
        (v) => v === this.newPassword || "Passwords do not match",
      ],
      ConfirmDialog:false,
      rules1: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        // email: (value) => {
        //   const pattern =
        //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //   return pattern.test(value) || "Invalid e-mail.";
        // },
      },
      rules: {
        email: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        password: [
          (v) => !!v || "Password is required",
          (v) => v.length >= 6 || "Password must contain at least 6 characters",
        ],
        newPassword: [
          (v) => !!v || "Password is required",
          (v) => v.length >= 8 || "Min 8 characters",
        ],
        confirmPassword: [
          (v) => !!v || "Password is required",
          (v) =>
            (v && this.confirmPassword == this.newPassword) ||
            "Password not matching",
        ],
      },
    };
  },
  beforeCreate() {
    if (
      this.$store.getters.getApiCredentials.baseUrl.includes("staging") == true
    ) {
      this.$store.commit("set_build_value", "staging");
    } else if (
      this.$store.getters.getApiCredentials.baseUrl.includes("www") == true
    ) {
      this.$store.commit("set_build_value", "www");
    } else if (
      this.$store.getters.getApiCredentials.baseUrl.includes("dev") == true
    ) {
      this.$store.commit("set_build_value", "dev");
    }
  },
  mounted() {
    this.$store.commit("SET_AUTH", false);
    // console.log(
    //   "verification_status",
    //   this.$store.getters.get_VerificatnStatus
    // );
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    isLargescreen() {
      return this.$vuetify.breakpoint.xlOnly;
    },
  },
  methods: {
    capsfnction() {
      this.display_id = this.display_id.toUpperCase();
    },
    forgotPassword() {
      this.$router.push("Forgotpwd");
    },
    signup() {
      this.$router.push("signup");
    },

    async redirectUser(email) {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: email.trim(),
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        // console.log("userlist", responseData.data.data);
        var rowlist = responseData.data.data;

        this.$store.commit("SET_corpid", responseData.data.data.corp_id);
        this.$store.commit("SET_userid", responseData.data.data.user_id);
        // console.log("userid", responseData.data.data.user_id);
        this.$store.commit("SET_Cusdetails", rowlist);
        this.$store.commit(
          "SET_VerificatnStatus",
          responseData.data.data.verification_status
        );

        this.$store.commit("SET_InWrkFlow", responseData.data.data.in_workflow);
        this.verificationstatus = responseData.data.data.verification_status
        if (
          responseData.data.data.verification_status === 0 ||
          responseData.data.data.verification_status === 2
        ) {
          this.$router.push("OnBoard");
          this.$store.commit("snackbar/showMessage", {
            content: "Login Successful! Please fill out the enrollment details",
            color: "green",
          });
        }
        if (responseData.data.data.verification_status === 3) {
          this.$router.push("OnBoard");
          this.$store.commit("snackbar/showMessage", {
            content: "Login Successful! Please Wait for Approval ",

            color: "green",
          });
        }
        if (responseData.data.data.verification_status === 1) {
          this.$router.push("Dashboard");
          this.$store.commit("snackbar/showMessage", {
            content: "Login Successful!",
            timeout: 500,
            color: "green",
          });
        }
        if(responseData.data.data.verification_status === 4 || responseData.data.data.verification_status === 5
          ||responseData.data.data.verification_status === 6
        ){
          this.ConfirmDialog = true;
          this.loadingLogin = false;
        }
       
      } else if (responseData.data.status == "ERROR") {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "red",
        });
        this.loadingLogin = false;
      }

      // if (this.userList.data.corp_id != "0") {
      //   this.$router.push("OnBoard");
      //   this.$store.commit("snackbar/showMessage", {
      //     content: "Login Successful! Please fill out the enrollment details",
      //     color: "green"
      //   });
      // }
    },
    navigatortoLogin() {
      this.ConfirmDialog = false;
      this.$router.push("/");
    },
    async login() {
      if (this.$refs.form.validate()) {
        this.loadingLogin = true;
        var inputData = {
          method_name: "CAUTH",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "LOGIN",
            email_id: this.email.trim(),
            password: this.password,
            display_id: this.display_id,
          },
        };
        var responseData = await apiCall(inputData);
        //    console.log("CAUTH", responseData);
        if (responseData.data.status == "00") {
          var rowlist1 = responseData.data.data;

          if (responseData.data.data.login_type == 2) {
            this.$store.commit(
              "SET_display",
              responseData.data.data.login_type
            );
            this.$store.commit("SET_AUTH", true);

            this.$store.commit("SET_USEREMAIL", this.email.trim());
            this.$store.commit(
              "SET_InWrkFlow",
              responseData.data.data.in_workflow
            );
            this.$store.commit("SET_refdetails", rowlist1);
            this.$router.push("/ReferrerDashboard");
          } else {
            this.$store.commit(
              "SET_display",
              responseData.data.data.login_type
            );
            this.redirectUser(this.email);
            this.$store.commit("SET_AUTH", true);

            this.$store.commit("SET_USEREMAIL", this.email.trim());
            this.$store.commit(
              "SET_InWrkFlow",
              responseData.data.data.in_workflow
            );
          }
        } else if (responseData.data.status == "NewPasswordRequired") {
          // console.log(responseData.data.data.session);

          var data = {
            session: responseData.data.data.session,
            email: this.email.trim(),
            display_id: this.display_id,
          };

          this.$store.commit("SET_session", data);
          this.$router.push("/Temppassword");
        } else if (responseData.data.status == "USRNTEXT") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.loadingLogin = false;
        } else if (responseData.data.status == "ERROR") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.loadingLogin = false;
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.loadingLogin = false;
        }
        // Auth.signIn(this.email, this.password)
        //   .then((user) => {
        //     this.user = user;
        //     console.log("user", user);
        //     if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        //       this.password - "";
        //       this.showDialog = true;
        //       this.loadingLogin = false;
        //       this.$store.commit("SET_USEREMAIL", this.email);
        //     } else {
        //       // other situations
        //       this.loadingLogin = false;
        //       // TO DO push them either to user or
        //       // commit auth
        //       this.redirectUser(this.email);
        //       this.$store.commit("SET_AUTH", true);
        //       this.$store.commit("SET_USEREMAIL", this.email);
        //     }
        //   })
        //   .catch((e) => {
        //     this.loadingLogin = false;
        //     this.$store.commit("snackbar/showMessage", {
        //       content: "Username or password is incorrect!",
        //       color: "red",
        //     });
        //     console.log(e);
        //   });
      }
    },
  },
};
</script>

<style scoped>
#login {
  height: 100%;
  width: 100%;
  /* position: fixed; */
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-image: url("~@/assets/GlydBackground.png");
  background-position: center center;
  /* -webkit-filter: blur(4px);
  filter: blur(4px); */
  /* background-color: black; */
  /* background-color: white; */
  background-repeat: no-repeat;
  background-size: 100%;
  touch-action: none;
}
#body {
  height: 100%;
  width: 100%;
  /* position: fixed; */
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  touch-action: none;
}
</style>
